import React, {useState} from 'react';

import {useQuery} from '@apollo/react-hooks';
import pricingsQuery from '../../../server/graphql/pricings/pricingsQuery';
import {updatePricings, getListingIds} from './helpers';

import {getRefinements} from '../../utils/edap';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import {AllListingsButtonComponent} from '../../components/common/listings/AllListingsButton';
import {CardCarousel} from '../../components/common/carousel/Carousel';
import {ListingsRatioCard} from '../../components/common/carousel/ListingsCard';
import {SeeMorePropertiesRatioCard} from '../../components/common/carousel/SeeMorePropertiesCard';
import {isPropertyTypeAll} from '../../utils/property-types';

import {listingAsPropertyRatioCard} from './components/Listings';
import SegmentFilters from './components/SegmentFilters';
import {RetryCard} from './components/RetryCard';

import {ACTION_LOCATION, handleNext, handlePrev} from './events';
import {onFetchListingsRetry} from './redux';

import './styles.less';
import {selector} from '../../utils/wdio-selectors';

export function validListing({geoCode, price}) {
    return geoCode.addressLatLngIsValid && price.shortLabel;
}

export function convertListingToMarker(listing) {
    const id = `${listing.tripleId}-${listing.unitUuid}`;

    const position = {
        lat: listing.geoCode.latitude,
        lng: listing.geoCode.longitude,
    };

    const showExactLocation = listing.geoCode.showExactLocation;
    const key = listing.tripleId;

    return {
        id,
        position,
        showExactLocation,
        key,
        label: listing.price.shortLabel,
    };
}

const GreatPlacesToStayComponent = (props) => {
    const {
        classNameCta,
        dispatch,
        highlightedId,
        isMobile,
        lastCardUrl,
        lbsId,
        listings = [],
        mapTitle,
        propertyType,
        segmentFilters,
        segmentKey,
        title,
        abacus,
        tripboardComponent,
        aspectRatio = '4x3',
        usePropertyFeedAlternative,
    } = props;
    const [filterClicked, setFilterClicked] = useState(false);

    if (listings.length === 0) {
        return null;
    }
    const types = getRefinements({
        propertyType,
        refinementKey: segmentFilters.key,
    });

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {data, loading} = useQuery(pricingsQuery, {
        variables: {listingIds: getListingIds(listings)},
        ssr: false,
        errorPolicy: 'ignore',
        skip: !filterClicked || !usePropertyFeedAlternative,
    });

    updatePricings(listings, data?.getPricings);

    const propertyRatioCards = listings.slice(0, 6).map(
        listingAsPropertyRatioCard({
            dispatch,
            types,
            highlightedId,
            isMobile,
            tripboardComponent,
            Card: ListingsRatioCard,
            segmentKey,
            abacus,
            hasEdapFastPathEvents: true,
            loading: usePropertyFeedAlternative && loading,
        })
    );

    propertyRatioCards?.push(
        <SeeMorePropertiesRatioCard
            abacus={abacus}
            key={-1}
            lastCardUrl={lastCardUrl}
            lbsId={lbsId}
        />
    );

    const prominentCta = (
        <AllListingsButtonComponent
            {...props}
            dispatch={dispatch}
            types={types}
            className={classNameCta}
            label={mapTitle}
            lastCardUrl={lastCardUrl}
            hasEdapFastPathEvents
            edapEventName={'content_tile.selected'}
        />
    );

    const fetchRetryCard = (
        <RetryCard
            onClickHandler={onFetchListingsRetry(dispatch, segmentKey)}
        />
    );

    const carouselElement = (
        <div className={'card-carousel'}>
            <CardCarousel
                titleMessage={''}
                aspectRatio={aspectRatio}
                onNextClick={handleNext}
                onPreviousClick={handlePrev}
            >
                {propertyRatioCards}
            </CardCarousel>
        </div>
    );

    const carousel =
        isMobile && segmentFilters.failed ? fetchRetryCard : carouselElement;

    const filters = (
        <div className={'great-places-to-stay__filters'}>
            <SegmentFilters setFilterClicked={setFilterClicked} />
        </div>
    );
    const displayFilters = isPropertyTypeAll(propertyType) ? filters : '';

    return (
        <div
            className={
                'container module module--no-padding great-places-to-stay'
            }
            data-wdio={selector.greatPlacesToStay}
        >
            <EdapViewTracker
                eventData={{
                    action_location: ACTION_LOCATION,
                    position_fired: 'top',
                }}
                edapEvent={'content_module.presented'}
            />
            <div className={'great-places-to-stay-hd'}>
                <h2 className={'great-places-to-stay__title'}>{title}</h2>
                {displayFilters}
            </div>
            {carousel}
            {isMobile && prominentCta}
            <EdapViewTracker
                eventData={{
                    action_location: ACTION_LOCATION,
                    position_fired: 'bottom',
                }}
                edapEvent={'content_module.presented'}
            />
            <EdapViewTracker eventData={{actionlocation: ACTION_LOCATION}} />
        </div>
    );
};
export default GreatPlacesToStayComponent;
